import React, { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../actions/user.actions";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { fieldRequiredMessage } from "../../errors/errors";
import Error from "../../components/Alert/Error";
import PasswordInput from "../../components/forms/PasswordInput";
import SuccessAlert from "../../components/Alert/SuccessAlert";
import { useEffect } from "react";
import EmailInput from "../../components/forms/EmailInput";
export default function Login() {
  const [submitted, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const {
    handleSubmit,
    getValues,
    register,
    setValue,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const alert = useSelector((state) => state.alert);
  const loggedIn = useSelector((state) => state.authentication.loggedIn);
  const navigate = useNavigate();
  const emailRef = useRef();
  const passwordRef = useRef();

  useEffect(() => {
    if (loggedIn) {
      navigate("/dashboard");
    }
  }, [loggedIn, navigate]);

  useEffect(() => {
    if (emailRef.current) {
      emailRef.current.focus();
      emailRef.current.click();
      setValue("Username", emailRef.current.value);
    }
  }, [emailRef, setValue]);

  useEffect(() => {
    if (passwordRef.current) {
      passwordRef.current.focus();
      passwordRef.current.click();
      setValue("Password", passwordRef.current.value);
    }
  }, [passwordRef, setValue]);

  useEffect(() => {
    if (alert.message) setLoading(false);
  }, [alert]);

  const onSubmitForm = async () => {
    const username = getValues().Username;
    const password = getValues().Password;
    setLoading(true);
    setSubmit({ submitted: !submitted });
    if (username && password) {
      dispatch(userActions.login(username, password));
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <div className="flex justify-center">
        <img
          src="/assets/images/colored-logo.svg"
          alt=""
          className="img-login w-4/4 sm:w-1/3 md:w-1/5"
        />
      </div>
      <div className="flex flex-center flex-col items-center my-9 w-[80%] md:w-3/5 lg:w-2/5 xl:w-1/4 mx-auto">
        <div className="login-input w-full mb-4">
          <EmailInput
            label="Login"
            id="username"
            name="username"
            register={{ ...register("Username", { required: true }) }}
            onChange={(e) => setValue("Username", e.target.value)}
            ref={emailRef}
          />
          {errors.Username && errors.Username.type === "required" && (
            <Error key={errorCount} text={fieldRequiredMessage("Email")} />
          )}
        </div>
        <div className="login-input w-full relative">
          <div className="relative">
            <PasswordInput
              name="loginPass"
              id="loginPass"
              placeholder="Password"
              label="Password"
              register={{ ...register("Password", { required: true }) }}
              onChange={(e) => setValue("Password", e.target.value)}
              ref={passwordRef}
            />
          </div>
          {errors.Password && errors.Password.type === "required" && (
            <Error key={errorCount} text={fieldRequiredMessage("Password")} />
          )}
        </div>

        <div className="links flex justify-between w-full text-[#3D4196] font-medium mt-2">
          <Link
            className="link text-[13px] hover:underline hover:text-coc-blue"
            to="/create"
          >
            Create new account
          </Link>

          <Link
            className="link text-[13px] hover:underline"
            to="/reset-password"
          >
            Forgotten password
          </Link>
        </div>

        <button
          type="submit"
          className="mt-9 login flex justify-center items-center text-md rounded-lg capitalize border-0 bg-[#3BB34B] hover:bg-[#329940] text-white w-full py-3"
          onClick={() => setErrorCount(errorCount + 1)}
        >
          {loading ? (
            <svg
              aria-hidden="true"
              role="status"
              className="inline w-4 h-4 mr-3 text-gray-200 animate-spin dark:text-gray-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="#1C64F2"
              />
            </svg>
          ) : (
            <img
              className="unlock mr-3 w-4 h-4 mb-[3px]"
              src="/assets/icons/unlock.svg"
              alt=""
            />
          )}
          <span className="leading-none">Login</span>
        </button>
        <div className="w-full">
          {alert.message && alert.type === "alert-danger" && (
            <Error key={errorCount} text={alert.message} />
          )}
          {alert.message && alert.type === "alert-success" && (
            <SuccessAlert message={alert.message} />
          )}
        </div>
      </div>
    </form>
  );
}
